
const { config } = require("./config");
var firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
if (!firebase.apps.length) {
  firebase.initializeApp(config);
}
const firestore = firebase.firestore();
const storage = firebase.storage();
const auth = firebase.auth();
const functions = firebase.functions();

const fb = { storage, firestore, auth, functions };

export default fb;
